import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { authService } from '@/services/auth'
import { useAuthStore } from '@/store/authStore'

export function CheckoutSuccess() {
  const updateUser = useAuthStore((state) => state.updateUser)
  const currentUser = useAuthStore((state) => state.user)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    const timeouts: ReturnType<typeof setTimeout>[] = []

    const refreshUser = async (attempts = 0) => {
      if (cancelled) return

      try {
        const user = await authService.getProfile()
        if (cancelled) return
        updateUser(user)

        if (user.tier === 'free' && attempts < 5) {
          timeouts.push(setTimeout(() => refreshUser(attempts + 1), 2000))
        } else {
          if (!cancelled) setLoading(false)
        }
      } catch (error) {
        console.error('Failed to refresh user:', error)
        if (!cancelled) setLoading(false)
      }
    }

    timeouts.push(setTimeout(() => refreshUser(0), 1000))

    return () => {
      cancelled = true
      timeouts.forEach(clearTimeout)
    }
  }, [updateUser])

  return (
    <div className="min-h-[calc(100vh-8rem)] flex items-center justify-center px-4">
      <Helmet>
        <title>Subscription Active | VaultLynk</title>
      </Helmet>
      <div className="text-center max-w-md">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>

        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          {loading ? 'Processing...' : `Welcome to ${currentUser?.tier === 'business' ? 'Business' : 'Premium'}!`}
        </h1>

        <p className="text-gray-600 mb-8">
          {loading
            ? 'Please wait while we activate your subscription...'
            : 'Your subscription is now active. You can now upload larger files, set longer expiry times, and access download analytics.'
          }
        </p>

        <div className="space-y-4">
          <Link to="/dashboard" className="btn-primary btn-lg w-full block">
            Go to Dashboard
          </Link>
          <Link to="/" className="btn-secondary btn-lg w-full block">
            Upload Files
          </Link>
        </div>
      </div>
    </div>
  )
}
